import { lazy } from 'react';


export const PasswordRecovery = lazy(() => import('./PasswordRecovery'));
